<template>
  <div class="formPosition" v-role="'ped'">
    <v-container class="grey lighten-5">
      <v-row no-gutters>
        <v-col>
          <!-- Título da página -->
          <h4 class="text-center"><span>Painel de Transferência - Pedidos de Transferências</span></h4>

          <!-- Contador de solicitações pendentes -->
          <label>
            Solicitações Pendentes
            <v-chip class="ma-2" color="pink" text-color="white">
              {{ pendingRequests.length }}
            </v-chip>
          </label>

          <!-- Overlay de carregamento -->
          <div class="text-center">
            <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">{{ $store.state.textMessage }}</div>
            <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <!-- Formulário de seleção de estudante e turma -->
            <v-container fluid>
              <v-row align="center">
                <!-- Campo de seleção de estudante -->
                <v-col class="d-flex" cols="3" sm="4">
                  <v-autocomplete v-model="selectedStudent" item-value="idMatricula" item-text="nomeEstudante"
                    :items="pendingRequests" label="Estudantes pendentes" :readonly="false" persistent-hint
                    prepend-icon="person" @change="selectStudent" return-object>
                  </v-autocomplete>
                </v-col>

                <!-- Campo de seleção de turma -->
                <v-col class="d-flex" cols="4" sm="4">
                  <v-select v-model="selectedClass" :items="filteredClasses" item-value="pkTurma" item-text="turmadescricao"
                    :rules="ruleRequired" :disabled="!selectedStudent || isDisabled" label="Selecione a Turma"
                    return-object></v-select>
                </v-col>

                <!-- Botão de confirmação -->
                <v-col class="d-flex" cols="3" sm="2">
                  <v-btn color="blue" :disabled="!selectedClass || isDisabled" style="color:white" @click="dialog = true">
                    Confirmar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
      </v-row>

      <!-- Diálogo de confirmação -->
      <v-dialog v-model="dialog" max-width="410">
        <v-card>
          <v-card-title class="headline"><v-icon color="blue">info</v-icon> Alerta</v-card-title>
          <v-card-text>
            Ao efectuar a Transferência, <strong>não será possível</strong> inverter a operação!
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="saveTransfer">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Card de detalhes do estudante -->
      <v-card class="mx-auto" v-if="studentDetails.length">
        <v-list-item>
          <v-list-item-avatar color="grey"></v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="headline">Dados do Estudante</v-list-item-title>
            <v-list-item-subtitle>Pesquisa Local - Estudante</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-row>
          <!-- Dados pessoais do estudante -->
          <v-col md="6">
            <v-card-text><strong>Dados Pessoais</strong></v-card-text>
            <hr>
            <v-list dense>
              <v-row>
                <v-col md="6">
                  <v-list-item><strong>Nome:</strong> {{ studentDetails[0].nome || '-' }}</v-list-item>
                </v-col>
                <v-col md="6">
                  <v-list-item><strong>Matrícula:</strong> {{ studentDetails[0].idMatricula || '-' }}</v-list-item>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <v-list-item><strong>Gênero:</strong> {{ studentDetails[0].sexo || '-' }}</v-list-item>
                </v-col>
                <v-col md="6">
                  <v-list-item><strong>Data de Nascimento:</strong> {{ studentDetails[0].datanascimento || '-' }}</v-list-item>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <v-list-item><strong>Natural de:</strong> {{ studentDetails[0].nomedopai || '-' }}</v-list-item>
                </v-col>
                <v-col md="6">
                  <v-list-item><strong>BI:</strong> {{ studentDetails[0].bi || '-' }}</v-list-item>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <v-list-item><strong>Filho de:</strong> {{ studentDetails[0].nomedopai || '-' }}</v-list-item>
                </v-col>
                <v-col md="6">
                  <v-list-item><strong>e de:</strong> {{ studentDetails[0].nomedamae || '-' }}</v-list-item>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <v-list-item><strong>Contato:</strong> {{ studentDetails[0].telefone || '-' }}</v-list-item>
                </v-col>
                <v-col md="12">
                  <v-list-item><strong>Instituição Proveniente:</strong> {{ selectedStudent ? selectedStudent.instituicao_proveniente : '-' }}</v-list-item>
                </v-col>
              </v-row>
            </v-list>
          </v-col>

          <!-- Histórico acadêmico do estudante -->
          <v-col md="6">
            <v-card-text><strong>{{ title }}</strong></v-card-text>
            <hr>
            <v-data-table :headers="headers" :items="studentDetails"></v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from '../../../plugins/axios';
import Swal from 'sweetalert2';
const ls = require('local-storage');

export default {
  data: () => ({
    pendingRequests: [],
    filteredClasses: [],
    selectedStudent: null,
    selectedClass: null,
    isDisabled: false,
    dialog: false,
    studentDetails: [],
    overlay: false,
    title: 'Histórico Acadêmico',
    ruleRequired: [value => !!value || 'Campo obrigatório'],
    headers: [
      { text: 'Curso - Inscrito', value: 'descricao_curso' },
      { text: 'Classes (Feitas)', value: 'classe' },
      { text: 'Turma', value: 'descricao_turma' },
      { text: 'Ano Lectivo', value: 'anoLectivo' },
      { text: 'Aproveitamento', value: 'resultado' }
    ]
  }),

  created() {
    this.initialize();
  },

  methods: {
    // Carrega as solicitações pendentes
    async initialize() {
      try {
        this.overlay = true;
        this.pendingRequests = await axios.get('/Listar_solicitacoes').then(res => res.data);
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro ao efectuar a operação', 'error');
      } finally {
        this.overlay = false;
      }
    },

    // Carrega os detalhes do estudante selecionado
    async selectStudent() {
      if (this.selectedStudent) {
        try {
          this.overlay = true;
          this.studentDetails = await axios.get(`/PesquisaInstituicaoEspecifica/${this.selectedStudent.idMatricula}/${this.selectedStudent.idinstituicaoProveniencia}`).then(res => res.data);
          if (this.studentDetails.length) {
            await this.loadClasses();
          }
        } catch (error) {
          Swal.fire('Informação', 'Ocorreu um erro ao selecionar o estudante', 'error');
        } finally {
          this.overlay = false;
        }
      }
    },

    // Carrega as turmas disponíveis
    async loadClasses() {
      try {
        this.overlay = true;
        let turmas = await axios.get(`/turmaFindAll/${this.studentDetails[0].idAno_Academico}/${this.studentDetails[0].anoLectivo}`).then(res => res.data);
        this.filteredClasses = turmas.filter( t=>t.idCurso === this.studentDetails[0].idCurso)
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro ao carregar as turmas', 'error');
      } finally {
        this.overlay = false;
      }
    },

    // Salva a transferência
    async saveTransfer() {
      if (this.selectedStudent && this.selectedClass) {
        const data = {
          idmatricula: this.selectedStudent.idMatricula,
          fkTurma: this.selectedClass.pkTurma,
          idturma: this.selectedClass.idTurma,
          pkinscricao_na_turma: this.studentDetails[this.studentDetails.length - 1].pkInscricao_na_turma,
          inscrito: 1
        };
        try {
          this.overlay = true;
          await axios.post('/Actualiza_Pessoa_transferencia', data);
          this.clearForm();
          Swal.fire('Informação', 'Operação realizada com sucesso!', 'success');
        } catch (error) {
          Swal.fire('Informação', 'Ocorreu um erro ao salvar a transferência', 'error');
        } finally {
          this.overlay = false;
          this.dialog = false;
        }
      }
    },

    // Limpa o formulário após a operação
    clearForm() {
      this.pendingRequests = this.pendingRequests.filter(request => request.idMatricula !== this.selectedStudent.idMatricula);
      this.selectedStudent = null;
      this.selectedClass = null;
      this.studentDetails = [];
      this.isDisabled = true;
    }
  }
};
</script>

<style scoped>
.formPosition {
  padding: 20px;
}
.text-center {
  text-align: center;
}
.mx-auto {
  margin: 0 auto;
}
.headline {
  font-size: 24px;
  font-weight: bold;
}
.v-card-text strong {
  font-weight: bold;
}
.v-list-item {
  padding: 8px 0;
}
.v-data-table {
  margin-top: 20px;
}
</style>